import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetListCards } from './useGetListCards'
import { ListCardsContent } from './ListCardsContent'

export const ListCardsComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data, refetch, isRefetching } = useGetListCards(id, tileFilterSelections)

  return (
    <ListCardsContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
      reloadHandler={refetch}
      isRefetching={isRefetching}
    />
  )
}

export function ListCardsComponentLoading() {
  return 'Loading...'
}
